module.exports = __webpack_public_path__ + "static/media/basicKit__light.ca75417a.jpg";